export const CONTINENT_CODES = {
  NORTH_AMERICA: [
    'CAN', 'USA', 'MEX', 'GTM', 'BLZ', 'HND', 'SLV', 'NIC', 'CRI', 'PAN',
    'CUB', 'JAM', 'HTI', 'DOM', 'BHS', 'TTO', 'GRL',
  ],
  SOUTH_AMERICA: [
    'COL', 'VEN', 'GUY', 'SUR', 'ECU', 'PER', 'BRA', 'BOL', 'PRY',
    'CHL', 'ARG', 'URY', 'FLK',
  ],
  ANTARCTICA: ['ATA', 'ATF'],
}

export const EXCLUDED_CONTINENTS = [
  'NORTH_AMERICA',
  'SOUTH_AMERICA',
  'ANTARCTICA',
]

export const EXCLUDED_COUNTRY_CODES = new Set(
  EXCLUDED_CONTINENTS.flatMap(continent => CONTINENT_CODES[continent])
)
